// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2Cd-x","noInteraction":"EventWrapper_noInteraction__2jsOc"};